import { Dropdown } from '@fluentui/react';
import React, { useMemo } from 'react';

const ProfileDropdown = (props) => {

    const {
        disabled = false,
        id = undefined
    } = props;

    const styles = useMemo(
        () => {
            return {
                label: {
                    color: disabled ? "#D9D9D9" : "black",
                    fontWeight: disabled ? 700 : 400,
                    fontSize: 14,
                    lineHeight: "18px",
                    textTransform: "uppercase",
                },
                dropdown: {
                    background: disabled ? "#FAFAFA !important" : "white !important",
                    borderRadius: 3,
                    height: 32,
                },
                title: {
                    background: "transparent",
                    border: disabled ? "1px solid #DBDBDB !important" : "1px solid black !important",
                    color: "black",
                    paddingTop: 2
                },
            };
        },
        [disabled]
    );

    return <Dropdown
        {...props}
        id={id}
        placeholder="-"
        styles={styles}
    />;

};

export default ProfileDropdown;